export const ErrorComponent = () => {
    return (
        <div id="error">
            <div id="box"></div>
            <h3>ERROR</h3>
            <h2>
                <b>Browser</b> <u>Not Supported</u>.
            </h2>
            <br />
            <p>
                Things are a little <span>unstable</span> here.
            </p>
            <br />

            <p>Your browser is currently not supported.</p>
            <br />

            <p>
                Please use{" "}
                <a
                    href="https://play.google.com/store/apps/details?id=com.android.chrome&hl=en_IN&gl=US"
                    target="_blank"
                    style={{ color: "#00a8ff" }}
                >
                    <u>Chrome</u>
                </a>{" "}
                for the best experience.
            </p>
            <br />

            <p>
                <u>Happy Learning!</u>
            </p>
        </div>
    );
};
